/**
 * Logging Service
 * 
 * Sends data to an external webhook for tracking missing products.
 * You can replace the WEBHOOK_URL with a Formspree, Discord, or Slack link.
 */

const WEBHOOK_URL = process.env.REACT_APP_WEBHOOK_URL;

export async function logMissingProduct(data) {
    if (!WEBHOOK_URL) {
        console.log('Logging (Simulation Mode):', data);
        return { success: true, simulated: true };
    }

    try {
        const response = await fetch(WEBHOOK_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                type: 'MISSING_PRODUCT_REPORT',
                timestamp: new Date().toISOString(),
                ...data,
            }),
        });

        return { success: response.ok };
    } catch (e) {
        console.error('Logging failed:', e.message);
        return { success: false, error: e.message };
    }
}
